export default __webpack_public_path__ + "static/media/movistar.09261be5.png";